export default "__VITE_ASSET__7cfc0a86__"